package com.devi3east.bashbuddy.features.events.feed.responses

import com.devi3east.bashbuddy.features.events.common.data.models.Event
import kotlinx.serialization.Serializable

@Serializable
data class EventFeedResponse(
    val events: List<Event> = emptyList(),
)
